export default __webpack_public_path__ + "static/media/mms.9782dc99.PNG";